import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Routes } from './routes'
import { LangProvider } from './i18n'
import './styles.css'

const el = document.getElementById('root')
if (!el) throw new Error('#root が見つかりません')

createRoot(el).render(
  <StrictMode>
    <LangProvider>
      <Routes />
    </LangProvider>
  </StrictMode>,
)
